import React, { PureComponent, Fragment } from 'react';
import cn from 'classnames';
import { FormattedMessage } from 'react-intl';
import { arrayMove } from 'react-sortable-hoc';
import { Fade, Button } from 'reactstrap';
import { object, array } from 'prop-types';
import DashboardSettingsSection from './DashboardSettingsSection';
import { ThemedFMessage } from '../../hoc/IntlComponents';
import { STATIC_PATH } from '../../config';
import SVG from 'react-inlinesvg';

const sortByPosition = (item, nextItem) => item.position - nextItem.position;

const makeConfigFromItems = (items = {}) =>
  Object.keys(items).reduce((acc, key) => {
    const config = items[key].map(({ id, enabled }, position) => ({
      id,
      position,
      enabled,
    }));

    return [...acc, ...config];
  }, []);

const makeItemsFromConfig = (items = {}, config = []) =>
  Object.keys(items).reduce((acc, key) => {
    const section = items[key]
      .map(({ id, title }, i) => {
        const settings = config.find((cfg) => cfg.id === id);

        if (settings) {
          const { enabled, position } = settings;
          return { id, title, enabled, position };
        }

        return { id, title, enabled: true, position: i };
      })
      .sort(sortByPosition);

    return { ...acc, [key]: section };
  }, {});

class DashboardSettings extends PureComponent {
  static propTypes = {
    items: object.isRequired,
    config: array.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      open: false,
      items: makeItemsFromConfig(props.items, props.config),
    };
  }

  toggle = () => {
    this.setState((prevState) => ({ open: !prevState.open }));
  };

  handleChange = ({ target }) => {
    const items = this.state.items[target.name];
    const id = parseInt(target.value, 10);

    if (items) {
      this.setState((prevState) => ({
        items: {
          ...prevState.items,
          [target.name]: items.map((item) => {
            if (item.id === id) {
              return { ...item, enabled: target.checked };
            } else {
              return item;
            }
          }),
        },
      }));
    }
  };

  handleSort = (prevPos, newPos, section) => {
    this.setState((prevState) => ({
      items: {
        ...prevState.items,
        [section]: arrayMove(prevState.items[section], prevPos, newPos),
      },
    }));
  };

  handleCancel = () => {
    this.setState(() => ({ open: false }));
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const config = makeConfigFromItems(this.state.items);

    this.setState(
      () => ({ open: false }),
      () => {
        this.props.onChange(config);
      },
    );
  };

  render() {
    const { open, items } = this.state;

    return (
      <>
        <button
          className={cn('dashboard-settings-trigger', { active: open })}
          type="button"
          onClick={this.toggle}
        >
          <SVG
            className="item-bin-icon"
            src={`${STATIC_PATH}/img/action-icons/settings-icon.svg`}
            height="20"
            width="20"
            cacheRequests
          />
        </button>

        {open && (
          <Fade in={open} className="dashboard-settings-widget-container">
            <div className="dashboard-settings-widget" onClick={this.handleCancel}>
              <form
                className="dashboard-settings-controls"
                onSubmit={this.handleSubmit}
                onClick={(e) => e.stopPropagation()}
              >
                <div className="dashboard-settings-header">
                  {/* <FormattedMessage
                    id="widgets.dashboard-settings.title"
                    defaultMessage="Page structure"
                  /> */}
                  <ThemedFMessage id="widgets.dashboard-settings.title" />
                  <button
                    type="button"
                    onClick={this.handleCancel}
                    className="dashboard-settings-button-close"
                  />
                </div>

                {Object.keys(items).map((key) => (
                  <DashboardSettingsSection
                    key={key}
                    title={key}
                    items={items[key]}
                    onSort={this.handleSort}
                    onItemChange={this.handleChange}
                  />
                ))}

                <div className="dashboard-settings-buttons">
                  <Button
                    type="button"
                    color="light"
                    onClick={this.handleCancel}
                    className="dashboard-settings-button-cancel"
                  >
                    <FormattedMessage id="main.cancel" defaultMessage="Cancel" />
                  </Button>
                  <Button type="submit" color="primary">
                    <FormattedMessage id="main.apply" defaultMessage="Apply" />
                  </Button>
                </div>
              </form>
            </div>
            <div className="modal-backdrop show" />
          </Fade>
        )}
      </>
    );
  }
}

export default DashboardSettings;
